import { BulkProcessFormData } from './bulk-process-utils.type';
import { createImportDataForBulkProcess } from './create-import-data-for-bulk-process';
import { processBulkProcessText } from './process-bulk-process-text';

// Helper function for handling bulk process submissions
export const handleBulkProcessSubmission = (
  bulkText: string,
  formData: BulkProcessFormData,
  submitFn: (importData: { importData: ReturnType<typeof createImportDataForBulkProcess> }) => void
) => {
  const { rows, totalQuantity } = processBulkProcessText(bulkText);
  const importData = createImportDataForBulkProcess(formData, rows, totalQuantity);
  submitFn({ importData });
};
